export default __webpack_public_path__ + "static/media/retangles-profile.b66328bd.svg";